module.exports = __webpack_public_path__ + "static/media/01.a1f14a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/shoes/01.png
// module id = 638
// module chunks = 0